import {isWithinInterval} from 'external/date-fns'
import {React, useContext, useHistory} from 'external/react'
import {styled, FormControl, Select, MenuItem, ArrowDropDownIcon} from 'external/material'

import {TeacherContext} from 'teacher/context'

const StyledSelect = styled(FormControl)(selectStyles)

export default function SelectPeriod () {

  const history = useHistory()
  const context = useContext(TeacherContext)

  const {link, linkQuery, periodTypesMap, groupId, query, translate} = context
  const {items, loaded} = context.rollbookContextPeriods
  const periods = items.map((period, i) => ({...period, name: `${translate(periodTypesMap[period.type])} ${i + 1}`}))
  const {periodId} = query

  const handlePeriodChange = event => {
    const {value: periodId} = event.target
    history.push(linkQuery(link({groupId}), {periodId}))
  }

  const selectedPeriod = periods.length == 0
    ? ''
    : (periodId || (periods.find(({start, finish}) => isWithinInterval(new Date(), {start, end: finish})) || {}).id || '')
  
  return (
    <StyledSelect>
      <Select
        variant="outlined"
        onChange={handlePeriodChange}
        value={selectedPeriod}
        IconComponent={ArrowDropDownIcon}
      >
        {periods.map((period, index) => (<MenuItem key={index} value={period.id}>{period.name}</MenuItem>))}
      </Select>
    </StyledSelect>
  )
}

function selectStyles() {
  return {
    "& > .MuiInputBase-root": {
      width: 200,
      height: 40
    },

  }
}
